import React from 'react';

import { Content as CommonContent } from '../common/Types.jsx';
import { withBlockRendering } from '../utility/Config.jsx';
import ContentContainer from '../common/ContentContainer.jsx';
import * as Image from './Image.jsx';
import * as ItemContainer from '../common/ItemContainer.jsx';
import { Component as ItemMetaComponent, TypeConfig as ItemMetaTypeConfig } from './ItemMeta.jsx';
import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import { default as _TypeConfig } from '../common/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

const Blocks = {
    get: (group, data) => [
        ...CommonContent.get(group),
        {
            id: Name.Block.Inventory.Image,
            component: Image.Component,
            config: {
                Block: Image.TypeConfig.panel.block(),
                Style: Image.TypeConfig.panel.style()
            },
            display: 'Item Image',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.Meta,
            component: ItemMetaComponent,
            config: {
                Block: ItemMetaTypeConfig.panel.block(data),
                Style: ItemMetaTypeConfig.panel.style()
            },
            display: 'Item Meta',
            group,
            image: ''
        }
    ]
}

function Page(props) {
    const handleComponentContent = (contentData, pageHeader, containerHandler) => {
        const content = [];
        if (!containerHandler) {
            return content;
        }
        let includes = {};
        if (props.config && props.config.config && props.config.config.Includes) {
            includes = props.config.config.Includes;
        }
        if (!contentData || contentData.length == 0) {
            return [containerHandler(0, 0, [{ index: content.length }], pageHeader)]
        }
        contentData.forEach((d, i) => {
            const insertInventoryPageBreak = i < contentData.length - 1;
            if (props.builder || !includes.AdditionalImages) {
                let image;
                if (d.Images && d.Images.length > 0) {
                    image = d.Images[0];
                }
                content.push(containerHandler(content.length, i, [{ image: image, index: content.length, itemData: d }], pageHeader, insertInventoryPageBreak));
            } else if (!d.Images || d.Images.length == 0) {
                content.push(containerHandler(content.length, i, [{ index: content.length, itemData: d }], pageHeader, insertInventoryPageBreak));
            } else {
                d.Images.forEach((image, imageIndex) => {
                    content.push(containerHandler(content.length, i, [{ alt: d.Title, image, index: content.length, itemData: imageIndex == 0 ? d : undefined }], pageHeader, insertInventoryPageBreak || imageIndex < d.Images.length - 1));
                });
            }
        });
        return content;
    }
    const data = props.data || {};
    let className = 'itemContainer pageBreakInsideAvoid';
    if (props.className) {
        className += ` ${props.className}`;
    }
    const visibilityHash = Utilities.Config.getVisibilityHash({ block: props.config });
    return (
        <ItemContainer.Page
            {...props}
            className={className}
            containerStyle={props.collateralType == 0 && { marginBottom: '200px' }}
            itemContentContainer={ItemContentContainer}
            items={data.Inventory}
            visibility={props.config && props.config.config && props.config.config.Visibility}
            visibilityHash={visibilityHash}
            onComponentContent={handleComponentContent} />
    )
}

const _ItemContentContainer = withBlockRendering(ContentContainer, Blocks.get(), (props, block) => {
    if (!block.type) {
        return;
    }
    switch (block.type.value) {
        case Name.Block.Columns:
            if (block.config && block.config.Block && block.config.Block.renderHeaderOnlyFirst) {
                return { renderHeader: props.index == 0 }
            }
    }
});
function ItemContentContainer(props) {
    let config = props.contentConfig;
    if (!config && props.config && props.config.config && props.config.config.Block && props.config.config.Block.design && props.config.config.Block.design.Config) {
        config = Utilities.Config.getDeepCopy(props.config.config.Block.design);
    }
    let componentData;
    if (props.componentData) {
        componentData = props.componentData;
        if (componentData && componentData.length) {
            componentData = componentData[0];
        }
        if (componentData && !componentData.itemData && config && config.Config && config.Config.blocks) {
            let temp;
            for (let i = 0; i < config.Config.blocks.length; i++) {
                temp = config.Config.blocks[i];
                if (!temp.type || temp.type.value != Name.Block.Inventory.Image) {
                    continue;
                }
                config.Config.blocks = [temp];
                break;
            }
        }
    } else if (props.data && props.data.Inventory && props.data.Inventory.length) {
        componentData = { itemData: { ...props.data.Inventory[0] } };
        if (componentData.itemData.Images && componentData.itemData.Images.length) {
            componentData.image = { ...componentData.itemData.Images[0] };
        }
    }
    if (!componentData) {
        componentData = {};
    }
    return <_ItemContentContainer {...props} {...componentData} contentConfig={config} />
}

const TypeConfig = {
    defaultDesign: (data) => ({
        "Config": {
            "blocks": [
                {
                    "config": {
                        "Block": {
                            "height": {
                                "unit": "px",
                                "value": "600"
                            },
                            "width": {
                                "unit": "px",
                                "value": "520"
                            }
                        },
                        "Style": {
                            "paddingBottom": {
                                "unit": "px",
                                "value": "20"
                            },
                            "textAlign": "center"
                        }
                    },
                    "id": `${Name.Block.Inventory.Image}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Image
                    }
                },
                {
                    "config": {
                        "Block": {
                            "design": ItemMetaTypeConfig.defaultDesign(data)
                        },
                        "Style": {}
                    },
                    "id": `${Name.Block.Inventory.Meta}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Meta
                    }
                }
            ]
        },
        "Type": Name.Content.TearsheetItem
    }),
    panel: {
        block: () => ItemContainer.TypeConfig.panel.block('block', Name.Content.TearsheetItem),
        includes: () => {
            return {
                options: [
                    {
                        display: 'Include Additional Images',
                        displayExport: 'Additional Images',
                        fullWidth: true,
                        group: 'block',
                        name: 'AdditionalImages',
                        type: 'checkbox',
                        value: true,
                        configurableDuringExport: () => true
                    }
                ]
            }
        },
        style: () => _TypeConfig.panel.layoutStyle('block', undefined, {}, undefined, {}),
        visibility: () => {
            return {
                expanded: false,
                label: 'Visibility',
                options: [
                    { display: 'Edition Info', name: Token.Inventory.Edition, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Edition, config, Name.Block.Inventory.Meta) },
                    { display: 'Created Date', name: Token.Date, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Date, config, Name.Block.Inventory.Meta) },
                    { display: 'Medium', name: Token.Inventory.Medium, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Medium, config, Name.Block.Inventory.Meta) },
                    { display: 'Signature Placement', name: Token.Inventory.Signature, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Signature, config, Name.Block.Inventory.Meta) },
                    { display: 'Dimensions', name: Token.Inventory.Dimensions, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Dimensions, config, Name.Block.Inventory.Meta) },
                    { display: 'Alternate Dimensions', name: Token.Inventory.AlternateDimensions, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.AlternateDimensions, config, Name.Block.Inventory.Meta) },
                    { display: 'Framing', name: Token.Inventory.Framed, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Framed, config, Name.Block.Inventory.Meta) },
                    { display: 'Inventory Number', name: Token.Inventory.Number, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Number, config, Name.Block.Inventory.Meta) },
                    { display: 'SKU', name: Token.Inventory.SKU, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.SKU, config, Name.Block.Inventory.Meta) },
                    { display: 'Location', name: Token.Inventory.Location, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Location, config, Name.Block.Inventory.Meta) },
                    { display: 'Retail Price', name: Token.Inventory.Price, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Price, config, Name.Block.Inventory.Meta) },
                    { display: 'Alternate Prices', name: Token.Inventory.AlternatePrices, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.AlternatePrices, config, Name.Block.Inventory.Meta) },
                    { display: 'Price Override', name: Token.Inventory.DisplayPrice, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.DisplayPrice, config, Name.Block.Inventory.Meta) },
                    { display: 'Sold', name: Token.Inventory.Sold, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Sold, config, Name.Block.Inventory.Meta) },
                    { display: 'Status Indicator', name: Token.Inventory.StatusIndicator, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.StatusIndicator, config, Name.Block.Inventory.Meta) },
                    { display: 'Inventory Notes', name: Token.Notes, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Notes, config, Name.Block.Inventory.Meta) },
                    { display: 'Private Inventory Notes', name: Token.PrivateNotes, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.PrivateNotes, config, Name.Block.Inventory.Meta) },
                    { display: 'Provenance', name: Token.Inventory.Provenance, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Provenance, config, Name.Block.Inventory.Meta) },
                    { display: 'Artist Biography', name: Token.Artist.Biography, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Artist.Biography, config, Name.Block.Inventory.Meta) }
                ],
                visible: () => false
            };
        }
    }
}

export {
    Blocks,
    ItemContentContainer as ContentContainer,
    Page,
    TypeConfig
};